/**
 * Event names carried on the app event bus. Websocket messages are re-emitted
 * under their own `type`, so these must match the server's message types.
 */
export const EVENT_TYPES = {
  CONNECTION_ERROR: 'connection-error',
  URL_STATUS: 'url-status',
};
